export default "__VITE_ASSET__DEaKHdhw__"